import { useEffect, useState } from 'react';
import { useIxcAssetsV1AssetCommandServiceGetLogo } from '../generated/hooks/ixc-assets-v1-asset-command-service-get-logo';

export function useAssetLogo(assetId: string | undefined) {
  const { data, isError, isPending } = useIxcAssetsV1AssetCommandServiceGetLogo(assetId ? { assetId } : undefined);

  const [logoSrc, setLogoSrc] = useState<string | undefined>();

  useEffect(() => {
    // data is typed as undefined but is actually a Blob at runtime
    const blob = data as unknown as Blob | undefined;

    if (!blob || !(blob instanceof Blob) || blob.size <= 0) {
      setLogoSrc(undefined);
      return;
    }

    const src = URL.createObjectURL(blob);
    setLogoSrc(src);

    return () => {
      URL.revokeObjectURL(src);
    };
  }, [data]);

  const hasLogo = Boolean(logoSrc) && !isError;

  return { logoSrc, hasLogo, isError, isPending };
}
